var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuscar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-24-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.573 14.472C25.573 8.4065 20.656 3.48944 14.5905 3.48944C8.52497 3.48944 3.60791 8.4065 3.60791 14.472C3.60791 20.5375 8.52497 25.4545 14.5905 25.4545C17.1277 25.4545 19.464 24.5942 21.3235 23.1492L28.7207 30.5437L30.6622 28.6023L23.2677 21.205C24.7126 19.3455 25.573 17.0092 25.573 14.472ZM6.35355 14.472C6.35355 9.92287 10.0413 6.23508 14.5905 6.23508C19.1396 6.23508 22.8274 9.92287 22.8274 14.472C22.8274 19.0211 19.1396 22.7089 14.5905 22.7089C10.0413 22.7089 6.35355 19.0211 6.35355 14.472Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscar);
export default __webpack_public_path__ + "static/media/buscar.61a6716d09344f4478b55307a33a1061.svg";
export { ForwardRef as ReactComponent };